import { DASHBOARD_PATH } from "@/utils/global-constants";
import { useI18n } from "@/utils/i18n";
import { useNavigate, useRouteError } from "react-router-dom";
import styles from "./error-boundary.module.css";

function ErrorFallback({ error }: { error: Error }) {
  const { t } = useI18n();
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.title}>{t("error.boundary.title")}</h1>
        <p className={styles.message}>{t("error.boundary.message")}</p>
        {import.meta.env.DEV && (
          <details className={styles.errorDetails}>
            <summary>{t("error.boundary.detail")}</summary>
            <pre className={styles.errorStack}>{error.stack ?? error.message}</pre>
          </details>
        )}
        <div className={styles.buttonContainer}>
          <button type="button" className={styles.button} onClick={() => navigate(DASHBOARD_PATH)}>
            {t("nav.dashboard")}
          </button>
          <button type="button" className={styles.button} onClick={() => window.location.reload()}>
            {t("common.refresh")}
          </button>
        </div>
      </div>
    </div>
  );
}

export function RouterErrorBoundary() {
  const routeError = useRouteError();
  const error =
    routeError instanceof Error
      ? routeError
      : new Error(typeof routeError === "string" ? routeError : "Unknown route error");

  return <ErrorFallback error={error} />;
}
